// Get element
var wrapper = document.getElementById("year-calendar");

// Function to format date according to locale
function formatDate(dateStr) {
    const langCode = trans('common.language_encode_short');
    const date = new Date(dateStr);
    return date.toLocaleDateString(langCode || 'en', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    });
}


function generateCalendars(givenDate, step) {
    const langCode = trans('common.language_encode_short');
    // Set default language for all calendars
    jsCalendar.options.language = langCode;


    $('#year-calendar').html('');

    if (step === undefined) {
        step = 0;
    }

    // Variables
    if (givenDate === undefined || parseInt(givenDate.split(',')[0]) + step == new Date().getMonth() + 1) {
        var date = new Date();
        var year = date.getYear() + 1900;
        var month = date.getMonth() + 1;
    } else {
        var date = null;
        var dArr = givenDate.split(',');
        var month = parseInt(dArr[0]) + step;
        var year =  parseInt(dArr[1]);
    }

    var newYear = year;

    var div;
    var newyearMonths = 0;
    var months = [];
    var monthsAsDate = [];

    // Create calendars
    var calendars = [];
    for (var i = 0; i < 3; i++) {
        // Create element
        div = document.createElement("div");
        wrapper.appendChild(div);
        // Create month calendar (we set the date to 0)

        if (i == 0) {
            if (month - i <= 0) {
                month = 12 + month;
                var newYear = newYear - 1;
                newyearMonths++;
            } else if (month - i > 12) {
                month = month - 12 + i;
                var newYear = newYear + 1;
            }
        } else {
            if (month - i <= 0) {
                month = 12 - newyearMonths + i;
                var newYear = newYear - 1;
                newyearMonths++;
            } else if (month - i > 12) {
                month = month - 12 + i;
                var newYear = newYear + 1;
            }
        }

        let calendar = jsCalendar.new(div, 0, {
            zeroFill : false,
            navigator : false,
            firstDayOfTheWeek: 2,
            language: langCode
        });
        // Force set language after creation
        calendar.setLanguage(langCode);
        calendars.push(calendar);

        calendars[i].goto("01-" + ((month - i < 10) ? "0" : "") + (month - i) + "-" + newYear);


        $('.jsCalendar:nth-of-type('+(i+1)+') .jsCalendar-title-name').append(' '+newYear);

        if (i == 0 || i == 2) {
            months.push([month - i + ', ' + newYear]);

            if (i == 0) {
                if (date !== null) {
                    monthsAsDate.push(new Date(Date.UTC(newYear , date.getMonth(), date.getDate()  )));
                } else {
                    monthsAsDate.push(new Date(Date.UTC(newYear , (((month - i < 10) ? "0" : "")  + (month - i)) , '0'  )));
                }

               // Set initial limits
                if (givenDate === undefined) {
                    $('.calendar-timepicker').attr('data-max-date', newYear+'-'+ (month - 1 - i)).attr('data-min-date', (newYear - 2)+'-'+ (month - 1 - i));
                }
            } else {
               monthsAsDate.push(new Date(Date.UTC(newYear , (((month - i - 1 < 10) ? "0" : "")  + (month - 1 - i)), '01'  )));
            }
        }
    }

    // Populate the time picker
    var startMonth = months[0];
    var endMonth = months[1];


    $('.calendar-timepicker').attr('data-start-date', startMonth).text(monthsAsDate[1].toLocaleString(trans('common.language_encode'), { month: 'short', year: 'numeric' }) + ' ' + trans('common.to') +' ' + monthsAsDate[0].toLocaleString(trans('common.language_encode'), { month: 'short', year: 'numeric' }) );

    callMonitorCalendar(monthsAsDate[0], monthsAsDate[1]);

    // Handle nav buttons
    var maxDate = $('.calendar-timepicker').attr('data-max-date').split('-');
    var minDate = $('.calendar-timepicker').attr('data-min-date').split('-');
    var actualDateM = parseInt(monthsAsDate[0].toLocaleString('default', { month: 'numeric' }));
    var actualDateY = parseInt(monthsAsDate[0].toLocaleString('default', { year: 'numeric' }));

    if (actualDateM >= parseInt(maxDate[1]) + 1 && actualDateY >= maxDate[0]) {
        $('.calendar-next').prop('disabled', true);
    } else {
        $('.calendar-next').prop('disabled', false);
    }

    if (actualDateM <= parseInt(minDate[1]) + 1 && actualDateY <= minDate[0]) {
        $('.calendar-prev').prop('disabled', true);
    } else {
        $('.calendar-prev').prop('disabled', false);
    }

}

$('.calendar-prev').on('click', function() {
    generateCalendars($('[data-start-date]').attr('data-start-date'), -3);
});

$('.calendar-next').on('click', function() {
    generateCalendars($('[data-start-date]').attr('data-start-date'), 3);
});



function callMonitorCalendar(start, end) {
    $.ajax({
        type: "GET",
        url: window.pspApiPath + '&startDate='+end.getTime() / 1000 +'&endDate='+start.getTime()  / 1000,
        dataType: "json",
        cache: false,
        retryLimit: 2,
        success: function(data) {
            var monitorName = data.monitor.name;
            var monthlyRatios = data.monitor.monthlyRatios;

            $('.monitor-name').text(monitorName + ' ' + trans('common.history_logs'));

            var days = data.days.reverse();

            // Generate bars for monitor
            $.each(data.monitor.dailyRatios.reverse(), function(i, daily){

                var notMonitored = false;
                var d = new Date(days[i]).getTime() / 1000;
                var formattedDate = formatDate(days[i]);
                var dataDisplayDay = daily.ratio + '%';

                if (d < data.monitor.createdAt - 86400) {
                    notMonitored = true;
                }

                /* set up a bar color based on value */
                var fillColor = "green"; // green color
                var fillOpacity = 1;

                if (notMonitored == true || daily.label == "black") {
                    fillColor = "";
                    dataDisplayDay = trans('common.no_records');
                    formattedDate = formatDate(days[i]);
                } else {
                    if (daily.ratio < 100 && daily.ratio >= 99) {
                        fillColor = "green"; // orange color
                        fillOpacity = 0.5;
                    } else if (daily.ratio < 99 && daily.ratio >= 95) {
                        fillColor = 'orange'; // orange color
                    } else if (daily.ratio < 95) {
                        fillColor = 'red'; // red color
                    }
                }

                var nDate = new Date(days[i]);
                var dateSelector = (nDate.getMonth() + 1) +'/'+ (nDate.getDate()) +'/'+(nDate.getYear() + 1900);

                var el = $('[data-date="'+dateSelector+'"]:not(.jsCalendar-next, .jsCalendar-previous)');

                var formattedDate = formatDate(days[i]);
                el.addClass(fillColor).css('opacity', fillOpacity).attr('uk-tooltip', '<div class=\'uk-text-muted font-12\'>'+ formattedDate + '</div>'+dataDisplayDay+'');

            });

            $.each($('[data-date]:not([uk-tooltip])'), function(i) {
                if(!$(this).hasClass("jsCalendar-next") && !$(this).hasClass("jsCalendar-previous")) {
                    var date = formatDate($(this).data('date'));
                    $(this).attr('uk-tooltip', '<div class=\'uk-text-muted font-12\'>' + date + '</div> ' + trans('common.no_records'));
                }
            });

            if (window.showUP) {
                var c = 1;
                $.each(monthlyRatios, function(i) {
                    $('.jsCalendar:nth-of-type('+c+') .jsCalendar-title-right').text(parseFloat(monthlyRatios[i])+'%');
                    c++;
                });
            }

        },
        error: function(error) {
            console.log(error);
/*
            if (this.retryLimit > 0) {
                //try again
                $.ajax(this);
                return;
            } else {
                UIkit.modal('#error-modal').show();
                return;
            }

            this.tryCount--;*/
        }
    });
}

function generateMonitorList() {
    var pspID = $('#pspi').val();
    var mID = $('#mi').val();

    var list = '';

    $.ajax({
        type: "GET",
        url: '/api/listMonitorIds/'+pspID,
        dataType: "json",
        cache: false,
        success: function(data) {
            $.each(data, function(i){
                var item = $(this)[0];
                var selected = mID == item.id ? ' selected' : '';
                list += '<option value="'+item.id+'"'+selected+'>'+item.name+'</option>';
            });

            $('#calendar-monitor-chooser').append(list);
            $('#calendar-monitor-chooser').select2();
        },
        error: function(error) {
            console.log(error);
            UIkit.modal('#error-modal').show();
        }
    });
}


$(document).ready(function(){
    generateCalendars();
    generateMonitorList();

    $('#calendar-monitor-chooser').on('change', function() {
        var baseUrl = DOMPurify.sanitize($('link[rel="canonical"]').attr('href'));
        
        var id = $(this).val();
        window.location.href = baseUrl+id+'/calendar';
    });
});
